module.exports = __webpack_public_path__ + "img/icon_spjj_01.84e65ae0.png";